<div class="assessment-view-container">
  @if (loading) {
    <div class="loading-overlay">
      <mat-spinner diameter="60"></mat-spinner>
      <p>Loading assessment...</p>
    </div>
  }

  @if (error) {
    <mat-card class="error-card">
      <mat-card-content>
        <mat-icon color="warn">error</mat-icon>
        <h2>{{ error }}</h2>
        <button mat-raised-button color="primary" (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
          Go Back
        </button>
      </mat-card-content>
    </mat-card>
  }

  @if (!loading && !error && assessment) {
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav #actionsSidenav mode="side" opened position="start" class="actions-sidenav">
        <app-entity-actions-sidenav
          title="Assessment"
          [actions]="sidenavActions">
        </app-entity-actions-sidenav>
      </mat-sidenav>

      <mat-sidenav-content class="form-content">
        <div class="header-bar">
          <button mat-button (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
            Back
          </button>
          <h2>{{ assessment.name || 'Untitled Assessment' }}</h2>
          <mat-chip-set>
            <mat-chip>{{ assessment.status || 'No status' }}</mat-chip>
          </mat-chip-set>
        </div>

        <!-- Details -->
        <mat-card class="detail-card">
          <mat-card-header>
            <mat-card-title>Details</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="detail-grid">
              <div class="detail-item">
                <span class="label">Type</span>
                <span class="value">{{ assessment.type || '—' }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Source Record</span>
                <span class="value">{{ assessment.sourceRecord || '—' }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Owner</span>
                <span class="value">{{ getPersonName(assessment.owner) }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Critical Date</span>
                <span class="value">{{ assessment.criticalDate ? (assessment.criticalDate | date:'MM/dd/yyyy') : '—' }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Assessor</span>
                <span class="value">{{ getPersonName(assessment.assessor) }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Final Reviewer</span>
                <span class="value">{{ getPersonName(assessment.finalReviewer) }}</span>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Quality Metrics -->
        @if (assessment.qualityMetricsLocation || assessment.qualityMetricsLanguageExcerpt) {
          <mat-card class="detail-card">
            <mat-card-header>
              <mat-card-title>Quality Metrics</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              @if (assessment.qualityMetricsLocation) {
                <div class="detail-item block">
                  <span class="label">Contract Location</span>
                  <span class="value">{{ assessment.qualityMetricsLocation }}</span>
                </div>
              }
              @if (assessment.qualityMetricsLanguageExcerpt) {
                <div class="detail-item block">
                  <span class="label">Contract Language Excerpt</span>
                  <div class="value html-block" [innerHTML]="assessment.qualityMetricsLanguageExcerpt"></div>
                </div>
              }
            </mat-card-content>
          </mat-card>
        }

        <!-- Evaluation Instructions -->
        @if (instructionsHtml) {
          <mat-expansion-panel class="detail-card">
            <mat-expansion-panel-header>
              <mat-panel-title>Evaluation Instructions</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="html-block" [innerHTML]="instructionsHtml"></div>
          </mat-expansion-panel>
        }

        <!-- Questions -->
        <mat-card class="detail-card">
          <mat-card-header>
            <mat-card-title>
              Questions
              <span class="total-score">Total Score: {{ totalScore }}</span>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            @if (!assessment.questionsAndAnswers?.length) {
              <p class="muted">No questions have been answered.</p>
            }
            @for (qa of assessment.questionsAndAnswers; track $index) {
              <div class="qa-row">
                <div class="qa-question">{{ qa.question }}</div>
                <div class="qa-answer">
                  <mat-chip-set>
                    <mat-chip>{{ scoreText(qa) }}</mat-chip>
                  </mat-chip-set>
                </div>
                @if (qa.comment) {
                  <p class="qa-comment">{{ qa.comment }}</p>
                }
              </div>
              @if (!$last) {
                <mat-divider></mat-divider>
              }
            }
          </mat-card-content>
        </mat-card>

        <!-- Recommendations -->
        @if (assessment.recommendation) {
          <mat-card class="detail-card">
            <mat-card-header>
              <mat-card-title>Recommendations</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="html-block" [innerHTML]="assessment.recommendation"></div>
            </mat-card-content>
          </mat-card>
        }

        <!-- Assessment History -->
        @if (history.length > 0) {
          <mat-card class="detail-card">
            <mat-card-header>
              <mat-card-title>Other Assessments on This Record</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <table class="history-table">
                <thead>
                  <tr><th>Name</th><th>Status</th><th>Assessor</th><th>Critical Date</th></tr>
                </thead>
                <tbody>
                  @for (h of history; track h.assessmentNum) {
                    <tr (click)="openAssessment(h)">
                      <td>{{ h.name || 'Untitled' }}</td>
                      <td>{{ h.status || '—' }}</td>
                      <td>{{ getPersonName(h.assessor) }}</td>
                      <td>{{ h.criticalDate ? (h.criticalDate | date:'MM/dd/yyyy') : '—' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </mat-card-content>
          </mat-card>
        }

        @if (attestationText) {
          <p class="attestation-text">{{ attestationText }}</p>
        }
      </mat-sidenav-content>
    </mat-sidenav-container>
  }
</div>
